export default function effectTarget(effectParams, $slideEl) {
  if (effectParams.transformEl) {
    return $slideEl.find(effectParams.transformEl).css({
      'backface-visibility': 'hidden',
      '-webkit-backface-visibility': 'hidden'
    });
  }

  return $slideEl;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/swiper/shared/effect-target.js
// module id = 4
// module chunks = 0 1